import { Controller } from 'stimulus'
import Rails from '@rails/ujs'

const maxPollingRetries = 60
const pollingInterval = 10000

export default class extends Controller {
  static targets = ['checkbox', 'selectAll', 'exportsCounter', 'spinner']
  static values = { exportsCount: Number }

  connect() {
    if (!this.hasExportsCountValue) { this.exportsCountValue = 0 }
    this._pollingRetries = 0
    this._timeout = null
    this.fetchExports()

    document.addEventListener(
      'export-list#updateExportCount',
      this.updateExportCount.bind(this)
    )
  }

  disconnect() {
    this.stopPollingTimeout()

    document.removeEventListener(
      'export-list#updateExportCount',
      this.updateExportCount.bind(this)
    )
  }

  exportsCountValueChanged() {
    if (this.exportsCountValue < 0) { this.exportsCountValue = 0 }
    this.exportsCounterTarget.innerHTML = this.exportsCountValue
  }

  updateExportCount(event) {
    const exportCount = (event.detail || { value: 0 }).value
    this.exportsCountValue = exportCount
  }

  fetchExports(page) {
    let formData = $('form').serialize()

    if (page) { formData = formData + '&' + page }

    Rails.ajax({
      type: 'get',
      url: '/exports',
      data: formData,
      dataType: 'script',
      success: () => {
        this.startLegacyExportsPolling()
      }
    })
  }

  onDeleteSuccess(event) {
    const exportListItemIdToDelete = event.target.dataset.referenceId.split('-')[2]
    this.removeExportListItemWithId(exportListItemIdToDelete, () => {
      this.exportsCountValue = this.exportsCountValue - 1
      if (this.checkboxTargets.length <= 0) {
        const reloadExportListEvent = new CustomEvent('export-filter#triggerFilter')
        document.dispatchEvent(reloadExportListEvent)
      }
    })
  }

  onDeleteFailure(event) {
    alert('The delete could not be completed.')
  }

  removeExportListItemWithId(id, afterItemRemovedCallback = () => {}) {
    const element = $(`#export_${id}`)
    element.fadeOut(() => {
      const checkbox = $(`#export-list-item-${id}`)[0]
      if (checkbox.checked) { checkbox.click() }
      element.remove()
      afterItemRemovedCallback()
    })
  }

  handleNewPage(event) {
    event.preventDefault()
    const href = event.currentTarget.href
    this.fetchExports(href.substr(href.search('page'), href.length))
  }

  startLegacyExportsPolling() {
    this._pollingRetries = 0
    this.stopPollingTimeout()
    this.startPollingTimeout()
  }

  startPollingTimeout() {
    this._timeout = setTimeout(() => this.fetchExternalExportsStatus(), pollingInterval)
  }

  stopPollingTimeout() {
    clearTimeout(this._timeout)
  }

  fetchExternalExportsStatus() {
    const externalExportsElements = document.querySelectorAll('.external-export')
    const externalExports = { ids: [] }

    externalExportsElements.forEach(item => {
      externalExports.ids.push(item.id.split('_')[1])
    })

    if (externalExports.ids.length > 0 && this._pollingRetries < maxPollingRetries) {
      this._pollingRetries += 1

      Rails.ajax({
        type: 'get',
        url: '/external_exports',
        data: $.param(externalExports),
        dataType: 'json',
        complete: () => this.startPollingTimeout(),
        error: () => console.log('Something went wrong')
      })
    }
  }
}
